import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { GanttDate, GanttGroup, GanttItem, GanttToolbarOptions, GanttViewOptions, GanttViewType, NgxGanttComponent, NgxGanttModule } from '@worktile/gantt';

export class TimeRange {
  constructor (public from : string, public to : string) {

  }
};

@Component({
  selector: 'schedule-time-range-chart',
  imports: [CommonModule, NgxGanttModule],
  templateUrl: './schedule-time-range-chart.component.html',
  styleUrl: './schedule-time-range-chart.component.css'
})
export class ScheduleTimeRangeChartComponent implements OnChanges{

  @ViewChild('gantt') gantt! : NgxGanttComponent;

  @Input() timeRanges: TimeRange[] = [];

  groups: GanttGroup[] = [];
  items: GanttItem[] = [];
  viewType: GanttViewType = GanttViewType.hour;
  toolbarOptions : GanttToolbarOptions = 
    { viewTypes: [  GanttViewType.day, 
                    GanttViewType.hour, 
                    GanttViewType.week, 
                    GanttViewType.month, 
                    GanttViewType.quarter, 
                    GanttViewType.year] 
    };
  
  today : Date = new Date();
  
  viewOptions: GanttViewOptions = {
    start: new GanttDate(new Date()),
    end: new GanttDate(new Date().setDate(this.today.getDate()+ 1)),
    min: new GanttDate(new Date()),
    max: new GanttDate(new Date().setDate(this.today.getDate()+ 1)),
    cellWidth: 60
  };

  public taskSettings: any = {
    id: 'id',
    name: 'name',
    startDate: 'startDate',
    endDate: 'endDate'
  };


  ngOnChanges() {
    this.groups = [
      { id: '1', title: 'Time Ranges' }
    ];

    this.items = this.timeRanges.map((range, index) => ({
      id: String(index + 1),
      title: `${range.from} to ${range.to}` || `Task ${index + 1}`,
      start: this.convertToDate(range.from == null ? "00:00" : range.from, false),
      end: range.to ? this.convertToDate(range.to == null ? "23:59" : range.to , this.overnight(range)) : 1440,
      group_id: '1'
    }));

 }

 overnight(range : TimeRange) : boolean {
  let from : number[] = (range.from == null? '0:0' : range.from).split(":").map(Number);
  let to : number[] = (range.to == null? '23:59' : range.to).split(":").map(Number);

  let minFrom = from[0] * 60 + from[1];
  let minTo = to[0] * 60 + to[1];
  return minTo < minFrom;
 }

 convertToDate(time: string, overnight : boolean): Date  {
    const [hours, minutes] = time.split(':').map(Number);
    let now = new Date();

    if (overnight) {
      now = new Date(now.setDate(now.getDate() + 1));
    }
    now.setHours(hours, minutes, 0, 0);
    return now;
  }
}
